import { useState } from "react";

import ReadMoreSection from "@/elements/ReadMore";
import { AdminGenerateSampleMatchesForm } from "@/components/forms/admin/job/generate-sample-matches";
import { AdminGenerateSampleMatchesFormSchema } from "@/components/forms/admin/job/generate-sample-matches/schema";
import ApprovedCandidatesTable from "../approved-candidates/approved-candidates-table";
import ApprovedCandidateDrawer from "../approved-candidates/approved-candidate-drawer";

import { useAdminSampleJobCandidateQuery } from "@/queries/admin/job-sample-matches";

import { AdminPipelineCandidate } from "@/queries/admin/candidate-pipeline";

const JobSampleMatches = () => {
  const [jobTitle, setJobTitle] = useState("");
  const [jobDescription, setJobDescription] = useState("");
  const [selectedCandidate, setSelectedCandidate] =
    useState<AdminPipelineCandidate>();

  const { adminSampleJobCandidates, adminSampleJobCandidatesLoading } =
    useAdminSampleJobCandidateQuery({
      jobTitle,
      jobDescription,
    });

  return (
    <div>
      <h3 className="py-4 text-2xl font-semibold group-hover:underline text-left">
        Sample Matches
      </h3>
      <div className="w-full flex flex-col gap-4 items-start self-stretch">
        {adminSampleJobCandidates?.length ? (
          <>
            <div className="flex flex-col self-stretch gap-2">
              <p className="text-base text-[#181D27] font-semibold leading-6">
                Title: {jobTitle}
              </p>
              <ReadMoreSection
                maxLines={3}
                textClassName="text-[#5C6060]"
                readMoreClassName="font-semibold text-[#6941C6]"
              >
                Description: {jobDescription}
              </ReadMoreSection>
            </div>
            <ApprovedCandidatesTable
              candidates={adminSampleJobCandidates}
              setSelectedCandidate={setSelectedCandidate}
            />
          </>
        ) : (
          <AdminGenerateSampleMatchesForm
            onSubmit={(matches: AdminGenerateSampleMatchesFormSchema) => {
              setJobTitle(matches.jobTitle);
              setJobDescription(matches.jobDescription);
            }}
            disabled={adminSampleJobCandidatesLoading}
            defaultValues={{
              jobTitle,
              jobDescription,
            }}
          />
        )}
      </div>
      <ApprovedCandidateDrawer
        candidate={selectedCandidate}
        setOpen={() => setSelectedCandidate(undefined)}
      />
    </div>
  );
};

export default JobSampleMatches;
